import React from "react";
import SecStackReportPage from "../../../sec-stack-report/report-page";
import styles from "./distributor-stack-report.module.scss";

const DistributorStackReport = () => {
  return (
    <div className={styles.container}>
      <SecStackReportPage isDistributorView={true} />
    </div>
  );
};

export default DistributorStackReport;

